<template>
  <div class="flex flex-column w-full h-full">
    <div v-if="(!loaded)"><AppSpinner /></div>
    <div v-if="(loaded)" class="flex flex-column w-full h-full">
      <div class="flex flex-column w-full h-full">
        <div class="flex w-full font-bold text-lg text-white appColor-01-bg border-round-top-xl px-3 py-2">
          <div class="flex flex-grow-1" v-html="$store.state.txt_app.error_botName"></div>
          <div class="flex"><AppLang /></div>
        </div>
        <div class="flex w-full font-semibold text-xs text-white appColor-02-bg appColor-02-border border-2 border-solid px-3 py-1" v-html="'&nbsp;'"></div>
        <div class="flex w-full appGray-01-bg">
          <div class="shape-divider">
            <div class="shape-divider-top">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="flex w-full flex-grow-1 justify-content-center appGray-01-bg">
          <div class="bot-content w-full overflow-y-auto p-3">
            <div class="flex flex-column w-full justify-content-center p-4 gap-4">
              <font-awesome-icon icon="fa-solid fa-face-frown" size="3x" flip="horizontal" class="text-red-600" />
              <div class="text-center" v-html="$store.state.txt_app.error_botMsg"></div>
            </div>
          </div>
        </div>
        <div class="flex w-full appGray-01-bg">
          <div class="shape-divider">
            <div class="shape-divider-bottom">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="flex w-full font-bold appGray-02-bg border-round-bottom-xl">
          <div class="flex w-full align-items-center gap-3 p-3" style="height:70px;"></div>
        </div>
      </div>
      <div class="flex flex-column w-full justify-content-center mt-2">
        <a class="flex justify-content-center text-xs link" :href="$store.state.txt_app.error_poweredByUrl" target="_blank" v-html="$store.state.txt_app.bt_poweredBy + '&nbsp;' + '<b>' + $store.state.txt_app.error_poweredBy + '</b>'"></a>
      </div>
    </div>
  </div>
</template>

<script>
import AppLang from '@/components/AppLang.vue';
export default {
  components: {
    AppLang,
  },
  data() {
    return {
      loaded: false,
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      setTimeout(() => { this.loaded = true; }, 1000);
    },
  },
  created() {},
  mounted() {
    document.documentElement.style.setProperty('--appColor-01', '#0069D9');
    document.documentElement.style.setProperty('--appColor-02', '#007BFF');
    this.mt_start();
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
